import { Core, Decorative } from "@faire/design-tokens";
import { trackCareersPageBelongingatfaireView } from "@faire/web-api/events/careersPage/view/belongingatfaire";
import { useStrictLocalization } from "@faire/web/common/localization";
import { Column } from "@faire/web/slate/Layout";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React, { useEffect } from "react";

import { FooterSEOContent } from "@faire/retailer/components/Footer/FooterSEOContent";
import { TestimonialsCardSection } from "@faire/retailer/components/TestimonialsCardSection/TestimonialsCardSection";
import { BelongingEmployeeCommunities } from "@faire/retailer/views/careers/__internal__/BelongingAtFaire/BelongingEmployeeCommunities";
import { BelongingEmployeesCustomersSection } from "@faire/retailer/views/careers/__internal__/BelongingAtFaire/BelongingEmployeesCustomersSection";
import { BelongingHeroSection } from "@faire/retailer/views/careers/__internal__/BelongingAtFaire/BelongingHeroSection";
import { BelongingLifeAtFaire } from "@faire/retailer/views/careers/__internal__/BelongingAtFaire/BelongingLifeAtFaire";
import { BelongingPageLargeImage } from "@faire/retailer/views/careers/__internal__/BelongingAtFaire/BelongingPageLargeImage";
import { BelongingWordsInAction } from "@faire/retailer/views/careers/__internal__/BelongingAtFaire/BelongingWordsInAction";
import { FAIRE_BELONGING_EMPLOYEES } from "@faire/retailer/views/careers/__internal__/BelongingAtFaire/faireBelongingEmployees";
import { BelongingAtFaireFooterImage } from "@faire/retailer/views/careers/__internal__/components/FullWidthImages";
import { JobOpeningsSection } from "@faire/retailer/views/careers/__internal__/components/JobOpeningsSection";

export const BelongingAtFairePage: React.FC = () => {
  useEffect(() => {
    trackCareersPageBelongingatfaireView();
  }, []);
  const { strictLocalize } = useStrictLocalization();
  const BelongingPageLargeImageComponent =
    BelongingPageLargeImage(strictLocalize);
  return (
    <Column>
      <BelongingHeroSection />
      <BelongingEmployeesCustomersSection />
      <BelongingPageLargeImageComponent />
      <BelongingWordsInAction />
      <BelongingLifeAtFaire />
      <TestimonialsCardSection
        testimonials={FAIRE_BELONGING_EMPLOYEES(strictLocalize)}
        title={
          <StrictLocalMsg
            defaultMessage="Employee Voices"
            description={{
              text: "Title for careers testimonials carousel",
              img: "https://cdn.faire.com/fastly/85a32ef5968a5446ae852e06daa5c740a8c6281a7bf5f2c67ab88c2a75d54ee9.png",
            }}
          />
        }
        titleColor={Core.text.subdued}
        backgroundColor={Decorative.tint.neutral}
        textColor={Core.text.default}
        textStyle={{
          mobileAndAbove: "subheadingSansRegular",
          tabletAndAbove: "paragraphSansMedium",
          desktopAndAbove: "subheadingSansMedium",
          xLargeAndAbove: "sectionHeaderSansMedium",
        }}
      />
      <BelongingEmployeeCommunities />
      <JobOpeningsSection />
      <BelongingAtFaireFooterImage />
      <FooterSEOContent />
    </Column>
  );
};
